import React from 'react'
import {useNavigate} from 'react-router'
import {useSearchParams} from 'react-router-dom'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import OrderDetailAtom from '../../@atoms/to_content/order_detail/order_detail.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import utils from '../../utils'

interface OrderDetailsErrorProps {
  title: string
  errorMsg: string
  btnLabel: string
}

const OrderDetailsErrorComponent: React.FC<OrderDetailsErrorProps> = function ({
  title,
  errorMsg,
  btnLabel,
}) {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const orderGUID = params.get('orderGUID') || ''

  const handleClick = () => {
    utils.removeTokenFromStorage(orderGUID)
    navigate(`/login?orderGUID=${orderGUID}`)
  }

  return (
    <OrderDetailAtom>
      <TypographyAtom ahd_type="h7">{title}</TypographyAtom>
      <BoxAtom className="error-wrapper">
        <BoxAtom>
          <TypographyAtom ahd_type="calDateD">{errorMsg}</TypographyAtom>
          <BoxAtom>
            <ButtonAtom ap_type="primary" onClick={handleClick}>
              {btnLabel}
            </ButtonAtom>
          </BoxAtom>
        </BoxAtom>
      </BoxAtom>
    </OrderDetailAtom>
  )
}

export default OrderDetailsErrorComponent
